import { createStore, applyMiddleware, compose } from 'redux';
import { persistStore } from 'redux-persist';
// import logger from 'redux-logger';
import thunk from 'redux-thunk';

// import createSagaMiddleware from "redux-saga";

import rootReducer from './root.reducer';

// const sagaMiddleware = createSagaMiddleware();
const Middleware = [thunk];

if (process.env.NODE_ENV === 'development') {
  // Middleware.push(logger);
}

const enhanceComboser =
  typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
    : compose;

export const store = createStore(
  rootReducer,
  enhanceComboser(applyMiddleware(...Middleware))
);

export const persistor = persistStore(store);

const exportStore = { store, persistor };

export default exportStore;
